<template>
  <modal-template :is-open.sync="_isOpen">
    <div class="modal">
      <div class="modal-title">
        {{ text }}
      </div>
      <div class="modal-buttons">
        <custom-button class="modal-buttons-item" @click="$emit('yes', $event)"
          >はい</custom-button
        >
        <custom-button
          outlined
          class="modal-buttons-item"
          @click="$emit('no', $event)"
          >いいえ</custom-button
        >
      </div>
    </div>
  </modal-template>
</template>

<script>
import ModalTemplate from '~/components/molcules/ModalTemplate'
import CustomButton from '~/components/atoms/Button'

export default {
  components: {
    ModalTemplate,
    CustomButton
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: '本当にキャンセルしますか？この操作は取り消せません。'
    }
  },
  computed: {
    _isOpen: {
      get() {
        return this.isOpen
      },
      set(val) {
        this.$emit('update:isOpen', val)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.modal {
  padding: 24px;
  &-title {
    margin-bottom: 16px;
  }

  &-buttons {
    &-item {
      margin-bottom: 16px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
